export default "<a href={{routeTo}} class=\"primary-grey\"  (click)=\"onBtnClick()\" translate>{{btnLabel}}</a>\n";